import React from 'react';
import { Stats } from '@react-three/drei';
import { PointCloud } from './PointCloud';
import { CuboidGroup } from './CuboidGroup';
import { CameraRig } from './CameraRig';
import { CONFIG } from '../../index';

export function SceneView() {
  return (
    <>
      <ambientLight intensity={0.4} />
      <directionalLight position={[50, 50, 100]} intensity={0.6} />
      <PointCloud />
      <CuboidGroup />
      <CameraRig />
      {CONFIG.debugStats && <Stats />}
    </>
  );
}
